import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class PlanningDashboardOverviewController extends Controller {
  @service intl;
  @service router;

  get tabs() {
    return [
      {
        label: this.intl.t('dictionary.matrix'),
        route: 'planning.dashboard.overview.grid',
      },
      {
        label: this.intl.t('dictionary.lanes'),
        route: 'planning.dashboard.overview.lanes',
      },
      {
        label: this.intl.t('pages.table'),
        route: 'planning.dashboard.overview.table',
      },
      {
        label: this.intl.t('dictionary.timeline'),
        route: 'planning.dashboard.overview.timeline',
      },
    ];
  }

  @action
  extractRouteName(name = '') {
    if (!name.includes('index')) return name;
    else {
      const routeParts = name.split('.');
      routeParts.splice(routeParts.length - 1, 1);
      return routeParts.join('.');
    }
  }

  @action
  isActive(tab) {
    const currentRouteName = this.extractRouteName(
      this.router.currentRoute?.name,
    );
    const tabRouteName = this.extractRouteName(tab.route);
    return currentRouteName === tabRouteName;
  }

  get activeTab() {
    const tab =
      this.tabs.filter((item) => this.isActive(item))?.[0] ?? this.tabs[0];
    return tab;
  }
}
